import { render, staticRenderFns } from "./MydtmSurvey.vue?vue&type=template&id=b68a48b6&"
import script from "./MydtmSurvey.vue?vue&type=script&lang=js&"
export * from "./MydtmSurvey.vue?vue&type=script&lang=js&"
import style0 from "./MydtmSurvey.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports